import { composeCouponConditionLabel } from '@cart-services/utils/composeCouponWording'
import { type AvailableCoupon } from '@hooks-api/types/dataModel/coupon'
import { type Ticket } from '@hooks-api/types/dataModel/ticket'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

export interface CouponConditionComposedLabelProps {
  coupon: AvailableCoupon | Ticket
  currency?: string
}

export const CouponConditionComposedLabel = (props: CouponConditionComposedLabelProps) => {
  const { coupon, currency } = props
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })

  const displayText = useMemo(() => {
    const couponDisplayText = composeCouponConditionLabel(coupon, '件', t, currency)
    return couponDisplayText.join(' / ')
  }, [coupon, currency, t])

  return (
    <Text
      variant="caption"
      color={colors.grey600}
    >
      {displayText}
    </Text>
  )
}
